module.exports = __webpack_public_path__ + "static/media/35.dcb76c0f.jpg";